import { useRef, useLayoutEffect } from 'react';

const endDayHour = 24;
interface UseScrollCalendarProps {
  scrollHour?: number;
  hourScrollOffset?: number;
}

export default function useScrollCalendar({
  scrollHour = 8,
  hourScrollOffset = -46,
}: UseScrollCalendarProps) {
  const schedulerWrapperRef = useRef<HTMLDivElement | null>(null);

  useLayoutEffect(() => {
    if (!schedulerWrapperRef?.current) {
      return;
    }

    const container = schedulerWrapperRef.current.querySelector(
      '.scheduler-wrapper .Container-container .MainLayout-container',
    ) as HTMLDivElement;

    if (container && scrollHour > 0) {
      const scrollPosition = scrollHour * (container.scrollHeight / endDayHour);
      container.scrollTop = scrollPosition + hourScrollOffset;
    }
  }, [hourScrollOffset, schedulerWrapperRef, scrollHour]);

  return schedulerWrapperRef;
}
